/* ==========================================================
   IL CAMPO "CERCA PRODOTTI" NELLA FASCIA NERA
   24 agosto 2026, chiesto da Alberto Quadrio e confermato: "il cerca
   prodotti mettilo nel fascione nero com'era una volta".

   E' UNO SPOSTAMENTO, NON UNA COSA NUOVA. Questo tasto esisteva gia' dal
   18 agosto: lo creava cube-collection.js e lo metteva nella fila dei
   comandi del catalogo, insieme a FILTRI, all'ordinamento e a CONFRONTA
   ORA. Da oggi nasce qui e va nella testata, al posto della lente. In
   cube-collection.js non c'e' piu' - resta solo il commento che dice dove
   e' finito.

   COSA CI GUADAGNA IL NEGOZIO, e non e' solo estetica:
   - la ricerca c'e' su OGNI pagina, non piu' solo nei cataloghi. Prima da
     una scheda prodotto o dal carrello si poteva solo cercare la lente;
   - la fila dei comandi del catalogo perde il pezzo piu' ingombrante:
     quel campo era largo 726px su 1165, cioe' quasi due terzi della riga.
     Restano tre bottoni allineati a destra.

   ==========================================================
   PERCHE' NON CERCA DA SOLO
   ==========================================================
   Sembra un campo di testo ma e' un bottone: aprendolo si spalanca il
   pannello di ricerca del tema, che mostra i risultati mentre si scrive.
   E' voluto, ed e' la decisione presa con Alberto il 18 agosto: un solo
   motore di ricerca da mantenere, non due. La barra dell'app Globo -
   quella che c'era prima - cercava solo dentro il reparto aperto, ed era
   scritto nel codice dell'app: "Use this input to search products in this
   collection". Un cliente nelle E-Bike che cercava "casco" non trovava
   niente. Quella barra e' spenta da layout/theme.liquid e nascosta da
   cube-controlli.css.

   ==========================================================
   COME SI APRE IL PANNELLO, e perche' non si preme piu' la lente
   ==========================================================
   Fino a ieri questo tasto premeva il bottone della lente in testata,
   lasciando fare tutto al tema. Adesso quella lente la NASCONDIAMO noi -
   il campo bianco prende il suo posto - e premere un bottone nascosto non
   funziona: provato, il pannello non si apre.

   Si chiede quindi direttamente al tema di aprirlo. Il pannello e' un
   <dialog-component id="search-modal"> che espone un metodo showDialog():
   misurato, chiamandolo il campo compare E il cursore ci finisce dentro
   da solo, esattamente come premendo la lente.

   Le due vie di riserva restano, in ordine: se un domani quel metodo non
   ci fosse piu' si torna a premere una lente visibile, e se non ce ne
   fosse nessuna si va alla pagina /search. Meglio una ricerca meno comoda
   che un tasto morto.
   ========================================================== */
(function () {
  'use strict';

  var LENTE =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M8.5 3a5.5 5.5 0 0 1 4.23 9.02l4.13 4.12a.9.9 0 1 1-1.28 1.28l-4.12-4.13A5.5 5.5 0 1 1 8.5 3Zm0 1.8a3.7 3.7 0 1 0 0 7.4 3.7 3.7 0 0 0 0-7.4Z"/>' +
    '</svg>';

  function apriRicerca() {
    var pannello = document.getElementById('search-modal');
    if (pannello && typeof pannello.showDialog === 'function') {
      pannello.showDialog();
      return;
    }

    /* riserva: una lente visibile, se ce n'e' ancora una */
    var lenti = document.querySelectorAll('search-button button');
    for (var i = 0; i < lenti.length; i++) {
      if (lenti[i].getBoundingClientRect().height > 0) {
        lenti[i].click();
        return;
      }
    }

    window.location.href = '/search';
  }

  /* LA CLASSE SULLA TESTATA E' UNA CONFERMA, NON UN INTERRUTTORE.
     E' cube-cerca.css a nascondere la lente, ma solo dentro
     ".header.cube-cerca-in-testata": cosi' la lente sparisce SOLTANTO se
     il campo bianco e' davvero al suo posto. Se questo file non venisse
     caricato, o si fermasse a meta', la testata resta quella del tema con
     la sua lente funzionante invece di rimanere senza niente. */

  function posa() {
    var colonna = document.querySelector('.header__row--top .header__column--right');
    if (!colonna) return;

    if (!colonna.querySelector('.cube-cerca-tutto')) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cube-cerca-tutto';
      b.setAttribute('aria-haspopup', 'dialog');
      b.setAttribute('aria-label', 'Cerca in tutto il negozio');
      b.innerHTML = LENTE + '<span>Cerca Prodotti</span>';
      b.addEventListener('click', apriRicerca);
      colonna.insertBefore(b, colonna.firstChild);
    }

    var testata = colonna.closest('.header');
    if (testata) testata.classList.add('cube-cerca-in-testata');
  }

  function avvia() {
    posa();

    /* nell'editor del tema la testata viene ridisegnata da capo a ogni
       modifica delle impostazioni, e il campo se ne andrebbe con lei */
    document.addEventListener('shopify:section:load', posa);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();

/* ==========================================================
   LA X DELLE BARRE DI RICERCA CANCELLA IL TESTO, E BASTA
   13 ottobre 2026
   ==========================================================
   "se clicco sulla x semplicemente deve togliersi il testo, mica
   portarmi su un'altra pagina con altri prodotti. questa regola deve
   essere per qualsiasi di queste occasioni" - Marco.

   Nella pagina dei risultati la X del tema (.search__reset-button) e' un
   link a /search?type=product&q=: premendola si cambiava pagina e
   compariva una ricerca vuota, con altri prodotti. Adesso, per QUALSIASI
   X di una barra di ricerca che sia un link (tutte quelle che cambiano
   pagina), il clic si ferma qui: il campo si svuota, il cursore resta
   dentro pronto per scrivere, e la pagina non si muove. La X sparisce da
   sola col campo vuoto (lo fa gia' il CSS del tema).
   La X del pannello di ricerca della testata (predictive-search) e' un
   bottone che il tema gestisce gia' cosi': non si tocca.
   Ascoltato su tutto il documento e in cattura, cosi' vale anche per le
   barre che il tema ridisegna dopo il caricamento.
   ========================================================== */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var t = e.target;
    var x = t && t.closest ? t.closest('a.search__reset-button, form[role="search"] a[class*="reset"]') : null;
    if (!x) return;
    var modulo = x.closest('form');
    var campo = modulo ? modulo.querySelector('input[type="search"], input[name="q"]') : null;
    if (!campo) return;

    e.preventDefault();
    e.stopPropagation();
    campo.value = '';
    // avvisa il tema e le app che il testo e' cambiato
    campo.dispatchEvent(new Event('input', { bubbles: true }));
    campo.focus();
  }, true);
})();

/* ==========================================================
   LA BARRA DEI RISULTATI LARGA QUANTO IL MENU
   13 ottobre 2026
   ==========================================================
   "puoi farla larga quanto la prima scritta e l'ultima del menu sopra"
   - Marco. Nella pagina dei risultati la barra di ricerca (campo + tasto
   CERCA) comincia dove comincia la prima scritta del menu nero (BIKE
   2027) e finisce dove finisce l'ultima (NEWMEN). Il menu cambia con la
   finestra, quindi le misure le prende questo script, dalle scritte
   vere (il testo, non il riquadro del link che ha 10 px d'aria per
   lato, e senza la spaziatura dopo l'ultima lettera), e le scrive in due
   variabili sull'<html>: --cube-ricerca-sx (di quanto la barra parte
   dentro il suo contenitore) e --cube-ricerca-larga. Il CSS le usa solo
   con la classe cube-ricerca-come-menu e da 990 px in su (cube-filtri-
   scorri.css); sotto, dove il menu nero non c'e', resta la barra di
   prima.
   Si rimisura quando cambia la finestra, quando arrivano i caratteri e
   quando la barra cambia contenitore (lo fa cube-collection.js, quando
   arriva il tasto dei filtri di Globo). Non con il menu minimizzato: le
   scritte li' sono piu' piccole, e la barra, in cima alla pagina, non si
   vede comunque.
   ========================================================== */
(function () {
  'use strict';

  if (!/^\/search/.test(location.pathname)) return;

  var html = document.documentElement;
  var grande = window.matchMedia('(min-width: 990px)');
  var contenitore = null;

  function bordi(e) {
    var r = document.createRange();
    r.selectNodeContents(e);
    var b = r.getBoundingClientRect();
    var spazio = parseFloat(getComputedStyle(e).letterSpacing) || 0;
    return { sx: b.left, dx: b.right - spazio };
  }

  function misura() {
    var modulo = document.querySelector('#MainContent form.search-page-input__parent');
    var voci = Array.prototype.filter.call(
      document.querySelectorAll('.header__row--bottom .menu-list__link-title'),
      function (e) { return e.offsetWidth > 0; }
    );
    if (!grande.matches || !modulo || voci.length < 2) {
      html.classList.remove('cube-ricerca-come-menu');
      return;
    }
    if (html.classList.contains('cube-stretta')) return;

    var a = bordi(voci[0]);
    var z = bordi(voci[voci.length - 1]);
    var padre = modulo.parentElement;
    contenitore = padre;
    var pr = padre.getBoundingClientRect();
    var inizio = pr.left + (parseFloat(getComputedStyle(padre).paddingLeft) || 0);
    if (!(z.dx > a.sx)) return;

    html.style.setProperty('--cube-ricerca-sx', Math.round(a.sx - inizio) + 'px');
    html.style.setProperty('--cube-ricerca-larga', Math.round(z.dx - a.sx) + 'px');
    html.classList.add('cube-ricerca-come-menu');
  }

  var inCoda = false;
  function piuTardi() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      misura();
    });
  }

  function avvia() {
    misura();
    window.addEventListener('resize', piuTardi);
    if (grande.addEventListener) grande.addEventListener('change', piuTardi);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(piuTardi);
    window.addEventListener('load', piuTardi);
    var principale = document.getElementById('MainContent');
    if (principale && window.MutationObserver) {
      new MutationObserver(function () {
        var modulo = document.querySelector('#MainContent form.search-page-input__parent');
        if (modulo && modulo.parentElement !== contenitore) piuTardi();
      }).observe(principale, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();

/* ==========================================================
   I SEGNAPOSTO ANCHE NEI RISULTATI DELLA RICERCA
   13 ottobre 2026
   ==========================================================
   "effettua una ricerca facendo dei test noterai dei ritardi e piccoli
   bug che rendono tutto scattoso" - Marco. Misurato su /search?q=casco:
   finche' Globo non disegna i risultati (circa 2,5 s) la griglia e'
   vuota - le schede del tema sono nascoste apposta (cube-card.css) - e
   il piede della pagina sta subito sotto la barra; quando arrivano le
   schede il piede sparisce in fondo di colpo. Quel solo salto valeva
   0,54 di CLS (sotto 0,1 e' "buono").
   Come nei cataloghi (assets/cube-disponibilita-filtro.js, che li' fa lo
   stesso): sagome grigie nella griglia (un <li> in testa, che Globo
   riscrive insieme a tutto il resto) e rettangoli nella fila dei filtri
   (un ::after della fila, acceso dalla classe cube-attesa-filtri: dentro
   la fila Globo non tollera elementi in piu'). Spariscono nello stesso
   fotogramma in cui Globo disegna i suoi; dopo 12 secondi comunque. Il
   vestito e' in cube-filtri-scorri.css, "I SEGNAPOSTO".
   Solo se la ricerca ha risultati: a zero risultati la pagina e' un'altra
   (cube-ricerca-vuota, classe messa nell'<head> da layout/theme.liquid).
   ========================================================== */
(function () {
  'use strict';

  if (!/^\/search/.test(location.pathname)) return;
  if (!/[?&]q=[^&]/.test(location.search)) return;
  if (!window.MutationObserver || !window.requestAnimationFrame) return;

  var html = document.documentElement;
  if (html.classList.contains('cube-ricerca-vuota')) return;

  var SCHEDE = 6;
  var griglia = null;
  var filtriFatti = false;
  var grigliaFatta = false;

  function luce(classe) {
    var e = document.createElement('div');
    e.className = 'cube-attesa ' + classe;
    e.setAttribute('aria-hidden', 'true');
    return e;
  }

  function filtriVeri() {
    var b = document.querySelectorAll('#gf-tree .gf-option-block:not(.cube-tipologia)');
    for (var i = 0; i < b.length; i++) if (b[i].offsetWidth > 0) return true;
    return false;
  }

  function sagome() {
    if (html.classList.contains('cube-ricerca-vuota')) {
      html.classList.remove('cube-attesa-filtri');
      if (griglia) griglia.remove();
      return true;
    }
    if (!filtriFatti && document.querySelector('#gf-tree') && filtriVeri()) {
      filtriFatti = true;
      html.classList.remove('cube-attesa-filtri');
    }
    if (!grigliaFatta) {
      if (document.querySelector('#gf-products .spf-product-card')) {
        grigliaFatta = true;
        if (griglia) griglia.remove();
      } else if (!griglia || !griglia.isConnected) {
        var ul = document.querySelector('#MainContent ul.product-grid');
        if (ul) {
          griglia = document.createElement('li');
          griglia.className = 'cube-attesa-griglia';
          griglia.setAttribute('aria-hidden', 'true');
          for (var j = 0; j < SCHEDE; j++) {
            var scheda = document.createElement('div');
            scheda.className = 'cube-attesa-scheda';
            scheda.appendChild(luce('cube-attesa-foto'));
            scheda.appendChild(luce('cube-attesa-riga'));
            scheda.appendChild(luce('cube-attesa-riga cube-attesa-riga--corta'));
            scheda.appendChild(luce('cube-attesa-riga cube-attesa-riga--prezzo'));
            griglia.appendChild(scheda);
          }
          ul.insertBefore(griglia, ul.firstChild);
        }
      }
    }
    return filtriFatti && grigliaFatta;
  }

  html.classList.add('cube-attesa-filtri');
  var inCoda = false;
  var osserva = new MutationObserver(function () {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      if (sagome()) osserva.disconnect();
    });
  });
  osserva.observe(html, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  if (sagome()) osserva.disconnect();
  setTimeout(function () {
    osserva.disconnect();
    html.classList.remove('cube-attesa-filtri');
    if (griglia) griglia.remove();
  }, 12000);
})();

/* ==========================================================
   LA SPINTA A GLOBO QUANDO SI FERMA   (14 ottobre 2026)
   ==========================================================
   Il 14 ottobre l'app Globo si e' aggiornata da sola (versione
   smart-product-filters-1133, il giorno prima era la 1131). Da quel
   momento cataloghi e risultati restavano senza filtri e senza prodotti
   su TUTTI i temi, anche sul pubblicato e su un Horizon senza nessuna
   nostra modifica: l'app scarica i dati (la richiesta di anticipo
   risponde 200) ma non li usa mai, e la pagina resta con la classe
   spf-filter-loading e la griglia vuota. Nessun errore in console.
   Provato a mano: chiamando la sua funzione globofilter.getFilterData()
   la pagina si riempie subito (10 filtri, 48 bici su E-BIKE).
   Qui: un attimo dopo il caricamento della pagina, se Globo e' ancora
   fermo (classe spf-filter-loading e nessun filtro nel suo stato), gli
   si chiede noi di caricare i dati; se serve si riprova un paio di
   volte. Quando Globo funziona da solo non fa niente: trova i filtri gia'
   caricati e si ferma. Da togliere quando Globo avra' sistemato.
   ========================================================== */
(function () {
  'use strict';

  if (!/^\/(collections|search)/.test(location.pathname)) return;

  var tentativi = 0;

  function fermo() {
    var g = window.globofilter;
    if (!g || typeof g.getFilterData !== 'function') return null;
    if (!document.documentElement.classList.contains('spf-filter-loading')) return false;
    var stato = g.state || {};
    if ((stato.filters && stato.filters.length) || (stato.products && stato.products.length)) return false;
    return g;
  }

  function prova() {
    var g = fermo();
    if (g === false) return;
    if (g) {
      try { g.getFilterData(); } catch (e) {}
    }
    if (++tentativi < 4) setTimeout(prova, 2000);
  }

  function avvia() { setTimeout(prova, 1500); }

  if (document.readyState === 'complete') avvia();
  else window.addEventListener('load', avvia);
})();

/* ==========================================================
   LA RICERCA FATTA RESTA NEL CAMPO DELLA TESTATA
   21 ottobre 2026
   ==========================================================
   "dopo che cerchi qualcosa dalla barra di ricerca del menu compare
   sopra il catalogo questa altra barra che non deve comparire. l'unica
   cosa che devi fare e' che si veda cosa hai cercato nella barra in alto
   del menu e quando clicchi sopra che si ricordi della ricerca cosi' da
   modificarla in modo semplice" - Marco.

   Nella pagina dei risultati:
   - il campo "Cerca Prodotti" della testata mostra la parola cercata
     (in nero, non piu' grigio come il segnaposto);
   - aprendo il pannello di ricerca (dal campo, o dalla lente da
     telefono) la parola e' gia' scritta, col cursore in fondo, e i
     risultati compaiono subito: basta correggerla. Se la si cancella
     resta cancellata finche' il pannello non si chiude.
   La barra grande sopra i filtri la nasconde cube-cerca.css (da 750 px
   in su, dove c'e' il campo in testata; da telefono resta, perche' li'
   in testata c'e' solo la lente).
   ========================================================== */
(function () {
  'use strict';

  if (!/^\/search/.test(location.pathname)) return;
  var q = '';
  try { q = (new URLSearchParams(location.search).get('q') || '').trim(); } catch (e) {}
  if (!q) return;
  // la prima lettera maiuscola, come scrive il campo (blocco qui sotto)
  q = q.replace(/^(\s*)(\p{Ll})/u, function (t, a, b) { return a + b.toUpperCase(); });

  function scrivi() {
    var b = document.querySelector('.cube-cerca-tutto');
    if (!b) return;
    var s = b.querySelector('span');
    if (s && s.textContent !== q) s.textContent = q;
    b.classList.add('cube-cerca-tutto--cercato');
    b.setAttribute('aria-label', 'Modifica la ricerca: ' + q);
  }

  /* NIENTE "VISUALIZZATI DI RECENTE" PER UN SECONDO (21 ottobre 2026):
     "quando c'e' qualcosa salvato nella barra ricerca prima mi fa vedere
     una roba diversa e poi arriva il risultato della ricerca giusto, ma
     passa quel sec che da' fastidio" - Marco. Aprendo il pannello il tema
     mostra subito quello che mostra a campo vuoto (visualizzati di
     recente e qualche prodotto) e i risultati della parola arrivano dopo
     (200 ms di attesa del tema + la richiesta). Finche' non arrivano, la
     zona dei risultati resta nascosta (classe cube-attesa-risultati,
     vestita in cube-cerca.css) e poi compare in dissolvenza. I risultati
     della parola si riconoscono dai link: quelli del tema portano
     _psq=<parola>, i visualizzati di recente no. Si mostra comunque se
     non arriva niente in 2,5 secondi, se si preme un tasto o se il
     pannello si chiude. */
  function attendi() {
    var m = document.getElementById('search-modal');
    var box = m && m.querySelector('[ref="predictiveSearchResults"]');
    if (!box || !window.MutationObserver) return;
    var fatto = false, oss = null, tempo = null;
    var d = m.querySelector('dialog');
    function mostra() {
      if (fatto) return;
      fatto = true;
      if (oss) oss.disconnect();
      clearTimeout(tempo);
      m.removeEventListener('keydown', mostra, true);
      if (d) d.removeEventListener('close', mostra);
      m.classList.remove('cube-attesa-risultati');
    }
    m.classList.add('cube-attesa-risultati');
    oss = new MutationObserver(function () {
      if (box.querySelector('a[href*="_psq="], [class*="no-results"]')) mostra();
    });
    oss.observe(box, { childList: true, subtree: true });
    tempo = setTimeout(mostra, 2500);
    m.addEventListener('keydown', mostra, true);
    if (d) d.addEventListener('close', mostra);
  }

  function riempi() {
    var c = document.querySelector('#search-modal input[type="search"], #search-modal input[name="q"]');
    if (!c || c.value) return;
    attendi();
    c.value = q;
    try { c.setSelectionRange(q.length, q.length); } catch (err) {}
    // il tema cerca a ogni "input", ma solo se sembra una battitura
    // (guarda inputType: con un Event semplice non parte): cosi' i
    // risultati arrivano subito
    var ev;
    try { ev = new InputEvent('input', { bubbles: true, inputType: 'insertText', data: q }); }
    catch (err) { ev = new Event('input', { bubbles: true }); }
    c.dispatchEvent(ev);
  }

  // quando il pannello passa da chiuso ad aperto la parola si riscrive
  // (se il campo e' vuoto); un secondo giro poco dopo, nel caso il tema
  // svuoti il campo mentre apre
  var aperto = false;
  function guarda() {
    var d = document.querySelector('#search-modal dialog');
    var ora = !!(d && d.open);
    if (ora && !aperto) {
      riempi();
      setTimeout(riempi, 150);
    }
    aperto = ora;
  }

  function avvia() {
    scrivi();
    document.addEventListener('shopify:section:load', scrivi);
    if (window.MutationObserver) {
      new MutationObserver(guarda).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    }
    guarda();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();

/* ==========================================================
   LA PRIMA LETTERA MAIUSCOLA NEI CAMPI DI RICERCA
   21 ottobre 2026
   ==========================================================
   "in entrambe le barre di ricerca la prima lettera e' sempre maiuscola
   poi il resto in base a come lo scrivono loro" - Marco. Prima il campo
   del pannello scriveva tutto in maiuscolo (text-transform di
   cube-ricerca-popup.css, ora spento in cube-cerca.css) e il campo della
   testata mostrava la parola cosi' com'era.
   Il CSS non sa alzare solo la prima lettera dentro un campo di testo
   (::first-letter li' non funziona, capitalize alza ogni parola): lo fa
   questo script mentre si scrive, lasciando il cursore dov'era. Il resto
   resta come lo scrive il cliente. La ricerca di Shopify non guarda
   maiuscole e minuscole, quindi i risultati sono gli stessi.
   Vale per il campo del pannello (testata e lente da telefono) e per la
   barra della pagina dei risultati. La parola mostrata nel campo della
   testata la sistema il blocco qui sopra.
   ========================================================== */
(function () {
  'use strict';

  var CAMPI = '#search-modal input[type="search"], #search-modal input[name="q"], #MainContent input.search-page-input';

  document.addEventListener('input', function (e) {
    var c = e.target;
    if (!c || !c.matches || !c.matches(CAMPI) || e.isComposing) return;
    var v = c.value;
    var nuovo = v.replace(/^(\s*)(\p{Ll})/u, function (t, a, b) { return a + b.toUpperCase(); });
    if (nuovo === v) return;
    var da = c.selectionStart, a = c.selectionEnd;
    c.value = nuovo;
    try { c.setSelectionRange(da, a); } catch (err) {}
  }, true);
})();

/* ==========================================================
   IL TASTO CERCA ACCANTO ALLA BARRA DEL PANNELLO
   21 ottobre 2026
   ==========================================================
   "il testo del tasto deve essere CERCA e non visualizza tutto. e poi
   lo vorrei accanto alla barra di ricerca e non sotto" - Marco.
   Il tasto VISUALIZZA TUTTO del tema sta in fondo ai risultati e compare
   solo quando ci sono risultati. Non lo si sposta (il tema lo ridisegna e
   lo comanda lui): se ne mette uno nostro, CERCA, nella riga del campo,
   fra il campo e la X, e quello del tema si nasconde (cube-ricerca-
   popup.css). Fa la stessa cosa: e' un tasto "invia" dello stesso modulo
   del campo, quindi porta alla pagina dei risultati della parola scritta.
   A campo vuoto non parte: il cursore torna nel campo.
   ========================================================== */
(function () {
  'use strict';

  function posa() {
    var testa = document.querySelector('#search-modal .predictive-search-form__header');
    if (!testa || testa.querySelector('.cube-cerca-vai')) return;
    var campo = testa.querySelector('.predictive-search-form__header-inner');
    if (!campo) return;
    var b = document.createElement('button');
    b.type = 'submit';
    b.className = 'cube-cerca-vai';
    b.textContent = 'Cerca';
    b.addEventListener('click', function (e) {
      var c = campo.querySelector('input[name="q"]');
      if (c && !c.value.trim()) {
        e.preventDefault();
        c.focus();
      }
    });
    campo.insertAdjacentElement('afterend', b);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', posa);
  else posa();
  document.addEventListener('shopify:section:load', posa);
})();
